import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { useConciergeCheck } from "./IsConcierge";

const AuthRedirect: React.FC = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  const isConcierge = useConciergeCheck();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  useEffect(() => {
    if (isConcierge === null || !isAuthenticated) return;

    if (isConcierge) {
      navigate("/concierge-dashboard", { replace: true });
    } else {
      navigate("/messages", { replace: true });
    }
  }, [isConcierge, isAuthenticated, navigate]);

  if (isLoading || isConcierge === null) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return null;
};

export default AuthRedirect;
